import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ChevronDownSmall } from '@starryui10/images/icons/ChevronDownSmall';
import { color } from '@starryui10/theme/color';
import { fontTypeToObject } from '@starryui10/theme/font';

interface ISelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    invalid?: boolean;
}

export const SelectInput = forwardRef<HTMLSelectElement, ISelectInputProps>(({ invalid, ...props }, ref) => (
    <Wrapper>
        <Select ref={ref} aria-invalid={invalid} {...props} />
        <Icon>
            <ChevronDownSmall color={color.Grey.G80} />
        </Icon>
    </Wrapper>
));

const Wrapper = styled.div`
    position: relative;
`;

const Icon = styled.div`
    height: 100%;
    position: absolute;
    right: 8px;
    display: grid;
    align-items: center;
    top: 0;
    pointer-events: none;
`;

const Select = styled.select`
    appearance: none;
    height: 40px;
    width: 100%;
    border: 1px solid ${color.Grey.G30};
    background-color: white;
    border-radius: 4px;
    text-indent: 8px;
    padding: 0;
    box-sizing: border-box;
    ${() => ({ ...fontTypeToObject('normal.regular') })}

    &[focus] {
        border-color: ${color.Blue.B60};
        outline: none;
    }

    &[aria-invalid='true'] {
        border-color: ${color.Red.R60};
    }

    &[disabled] {
        opacity: 0.4;
    }
`;
